module.exports = __webpack_public_path__ + "static/media/girl.b4831765.png";